document.addEventListener("DOMContentLoaded", function () {
  const learnMoreModal = document.getElementById("learn-more-modal");
  const closeModalButton = document.getElementById("close-modal-button");
  const learnMoreTrigger = document.getElementById("learn-more-trigger");
  const valueSections = document.querySelectorAll(".value-section");
  const valueImages = document.querySelectorAll(".value-image");

  // Create bottom close button element
  const bottomCloseButton = document.createElement("button");
  bottomCloseButton.className = "bottom-close-button";
  bottomCloseButton.setAttribute("aria-label", "Close modal");
  bottomCloseButton.innerHTML = `
      <span>Close</span>
      <div class="close-icon">
        <span class="x-line x-line-1"></span>
        <span class="x-line x-line-2"></span>
      </div>
    `;

  // Append the bottom close button to the modal
  learnMoreModal.appendChild(bottomCloseButton);

  // Handle scroll position for bottom close button
  function checkTopButtonVisibility() {
    // Only run if modal is active
    if (!learnMoreModal.classList.contains("active")) return;

    // Get position of top close button
    const topButtonRect = closeModalButton.getBoundingClientRect();

    // Check if top button is out of view (scrolled up out of the viewport)
    if (topButtonRect.bottom < 0) {
      // Show bottom button by adding class
      bottomCloseButton.classList.add("visible");
    } else {
      // Hide bottom button by removing class
      bottomCloseButton.classList.remove("visible");
    }
  }

  // Add scroll event listener for bottom button visibility within the modal
  learnMoreModal.addEventListener("scroll", function () {
    // Debounce scroll event to improve performance
    if (!this.bottomButtonTimeout) {
      this.bottomButtonTimeout = setTimeout(() => {
        checkTopButtonVisibility();
        this.bottomButtonTimeout = null;
      }, 50); // 50ms debounce
    }
  });

  function handleScrollImageChange() {
    const sections = document.querySelectorAll(".value-section");
    const images = document.querySelectorAll(".value-image");

    // Calculate scroll position
    const scrollPosition = window.scrollY + window.innerHeight / 2;

    // Check which section is in view
    sections.forEach((section) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.offsetHeight;
      const dataValue = section.getAttribute("data-value");

      if (
        scrollPosition >= sectionTop &&
        scrollPosition < sectionTop + sectionHeight
      ) {
        // Remove active class from all images
        images.forEach((img) => img.classList.remove("active"));

        // Add active class to corresponding image
        const targetImage = document.querySelector(
          `.value-image[data-value="${dataValue}"]`
        );
        if (targetImage) {
          targetImage.classList.add("active");
        }
      }
    });
  }

  // Add scroll event listener
  window.addEventListener("scroll", handleScrollImageChange);

  // Initial call to set correct image on page load
  document.addEventListener("DOMContentLoaded", handleScrollImageChange);

  if (closeModalButton && learnMoreModal) {
    // Save the original scroll position when opening the modal
    let scrollPosition = 0;

    // Function to disable body scroll
    function disableBodyScroll() {
      scrollPosition = window.pageYOffset;
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = "100%";
    }

    // Function to enable body scroll
    function enableBodyScroll() {
      document.body.style.removeProperty("overflow");
      document.body.style.removeProperty("position");
      document.body.style.removeProperty("top");
      document.body.style.removeProperty("width");
      window.scrollTo(0, scrollPosition);
    }

    // Close modal function to reuse in multiple places
    function closeModal() {
      // Close the modal
      learnMoreModal.classList.remove("active");
      learnMoreModal.setAttribute("aria-hidden", "true");

      // Re-enable scrolling
      enableBodyScroll();

      // Also reset the trigger button state if it exists
      if (learnMoreTrigger) {
        const plusIcon = learnMoreTrigger.querySelector(".plus-image");
        const minusIcon = learnMoreTrigger.querySelector(".minus-image");

        if (plusIcon && minusIcon) {
          plusIcon.style.display = "block";
          minusIcon.style.display = "none";
          learnMoreTrigger.setAttribute("aria-expanded", "false");
        }
      }
    }

    // Close button functionality
    closeModalButton.addEventListener("click", closeModal);

    // Add bottom close button functionality
    bottomCloseButton.addEventListener("click", closeModal);

    // Close modal on ESC key press
    document.addEventListener("keydown", function (event) {
      if (
        event.key === "Escape" &&
        learnMoreModal.classList.contains("active")
      ) {
        closeModal();
      }
    });

    // Optional: Close when clicking outside the content area
    learnMoreModal.addEventListener("click", function (event) {
      if (event.target === learnMoreModal) {
        closeModal();
      }
    });

    // Handling modal opening (if not defined elsewhere)
    if (learnMoreTrigger) {
      learnMoreTrigger.addEventListener("click", function () {
        learnMoreModal.classList.add("active");
        learnMoreModal.setAttribute("aria-hidden", "false");

        // Prevent background scrolling with improved method
        disableBodyScroll();

        // Set initial active image when opening modal
        setTimeout(checkVisibleSections, 100);

        // Also check bottom button visibility when opening
        setTimeout(checkTopButtonVisibility, 100);
      });
    }

    // Only run scroll detection on desktop
    if (window.innerWidth > 1024) {
      // Initial check when modal becomes active
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (
            mutation.attributeName === "class" &&
            learnMoreModal.classList.contains("active")
          ) {
            checkVisibleSections();
            checkTopButtonVisibility();
          }
        });
      });

      observer.observe(learnMoreModal, { attributes: true });

      // Check on scroll WITHIN THE MODAL
      learnMoreModal.addEventListener("scroll", function () {
        // Debounce scroll event to improve performance
        if (!this.scrollTimeout) {
          this.scrollTimeout = setTimeout(() => {
            checkVisibleSections();
            this.scrollTimeout = null;
          }, 50); // 50ms debounce
        }
      });

      // Improved function to check which section is visible
      function checkVisibleSections() {
        const modalRect = learnMoreModal.getBoundingClientRect();
        const modalScrollTop = learnMoreModal.scrollTop;
        const modalHeight = learnMoreModal.clientHeight;

        // Check if we're at the top of the modal (show main image)
        if (modalScrollTop < 100) {
          // Within 100px of the top
          // Show main image
          valueImages.forEach(function (img) {
            if (img.getAttribute("data-value") === "main") {
              img.classList.add("active");
            } else {
              img.classList.remove("active");
            }
          });
          return; // Exit early, don't check other sections
        }

        // Use a threshold to create a "buffer zone" to prevent flickering
        const triggerThreshold = 0.35; // Trigger when section is 35% into view
        const triggerPosition = modalHeight * triggerThreshold;

        // Track which section has the highest visibility
        let highestVisibilitySection = null;
        let highestVisibility = 0;

        // Determine which section is most visible
        valueSections.forEach(function (section) {
          const rect = section.getBoundingClientRect();

          // Calculate position relative to the modal
          const sectionTop = rect.top - modalRect.top;
          const sectionHeight = section.offsetHeight;

          // Calculate how much of the section is visible (0 to 1)
          let visibilityRatio = 0;

          // If section is in view
          if (sectionTop < modalHeight && sectionTop + sectionHeight > 0) {
            // Calculate visible area
            const visibleTop = Math.max(0, sectionTop);
            const visibleBottom = Math.min(
              modalHeight,
              sectionTop + sectionHeight
            );
            const visibleHeight = visibleBottom - visibleTop;

            // Calculate ratio of section that's visible
            visibilityRatio = visibleHeight / sectionHeight;

            // Apply a bias toward sections at the top of the viewport
            if (sectionTop < triggerPosition) {
              visibilityRatio *= 2; // Boost sections near the top
            }
          }

          // Keep track of most visible section
          if (visibilityRatio > highestVisibility) {
            highestVisibility = visibilityRatio;
            highestVisibilitySection = section;
          }
        });

        // If we found a visible section
        if (highestVisibilitySection) {
          const valueKey = highestVisibilitySection.getAttribute("data-value");

          // Update active image
          valueImages.forEach(function (img) {
            if (img.getAttribute("data-value") === valueKey) {
              img.classList.add("active");
            } else {
              img.classList.remove("active");
            }
          });
        }
      }
    }
  }
});
